import React from "react"
import { TextField } from "@material-ui/core"
import { Controller } from "react-hook-form"
import useStyles from "./SubscribeForm.styles"

const errorTexts = {
  required: "Please enter your email",
  pattern: "Please enter a valid email address",
}

const validationRules = {
  required: true,
  pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}

const EmailInput = ({ control, error, size }) => {
  const classes = useStyles({ size })

  const hasError = error !== undefined
  const errorText = hasError ? error.message || errorTexts[error.type] : undefined

  return (
    <Controller
      name="email"
      control={control}
      defaultValue=""
      rules={validationRules}
      render={props => (
        <TextField
          fullWidth
          label="Business Email"
          placeholder="Enter your business email"
          variant="filled"
          autoComplete="email"
          error={hasError}
          helperText={errorText}
          size="small"
          className={classes.input}
          style={{ marginBottom: size === "large" ? 16 : 0 }}
          InputProps={{
            className: classes.textInputProps,
          }}
          InputLabelProps={{
            className: classes.inputLabel,
          }}
          {...props}
        />
      )} // props contains: onChange, onBlur and value
    />
  )
}

export default EmailInput
